var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideMenu4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "107px",
    height: "107px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#000;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 16,
    className: "st0",
    width: 86.398,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.398,
    y: 16,
    className: "st0",
    width: 345.602,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    y: 216,
    className: "st0",
    width: 86.398,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.398,
    y: 216,
    className: "st0",
    width: 345.602,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    y: 416,
    className: "st0",
    width: 86.398,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.398,
    y: 416,
    className: "st0",
    width: 345.602,
    height: 80
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenu4);
export default __webpack_public_path__ + "static/media/side-menu4.46fab84422cb15bfb23ad77600ed819a.svg";
export { ForwardRef as ReactComponent };